"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const breadcrumbs_1 = __importDefault(require("@atlaskit/breadcrumbs"));
const { BreadcrumbsItem } = require("@atlaskit/breadcrumbs");
const react_apollo_1 = require("react-apollo");
const react_router_dom_1 = require("react-router-dom");
const page_layout_1 = require("./page-layout");
const loading_1 = require("../loading");
const categoryQuery = require("./category.query.graphql");
const utilities_1 = require("../utilities");
class CategoryBreadcrumbsView extends React.Component {
    constructor() {
        super(...arguments);
        this.navigateFn = (curPath) => () => {
            this.props.history.push("/categories/" + curPath);
        };
    }
    render() {
        if (this.props.data.category) {
            const path = this.props.data.category.name;
            const sections = path.split("/");
            let curPath = "";
            const items = sections.map((section) => {
                curPath += `${section}/`;
                const categoryPath = curPath.slice(0, -1);
                const pathname = this.props.location.pathname
                    .split("/")
                    .slice(2)
                    .join("/"); // full pathname w/o "categories"
                return (React.createElement(BreadcrumbsItem, { onClick: this.navigateFn(pathname.replace(this.props.match.params.id, encodeURIComponent(categoryPath)) + (this.props.location.search ? this.props.location.search : "")), text: section }));
            });
            return React.createElement(breadcrumbs_1.default, { maxItems: 10 }, items);
        }
        return null;
    }
}
exports.CategoryBreadcrumbsView = CategoryBreadcrumbsView;
exports.CategoryBreadcrumbs = utilities_1.compose(react_apollo_1.graphql(categoryQuery), react_router_dom_1.withRouter, loading_1.withLoadingSpinner)(CategoryBreadcrumbsView);
exports.CategoryBreadcrumbs.displayName = "CategoryBreadcrumbs";
class CategoryPageLayout extends React.Component {
    render() {
        return (React.createElement(page_layout_1.PageLayout, Object.assign({}, this.props, { breadcrumbs: React.createElement(exports.CategoryBreadcrumbs, Object.assign({ id: this.props.id }, this.props)) })));
    }
}
exports.CategoryPageLayout = CategoryPageLayout;
